import React, { useEffect } from 'react';
import '../css/animate.css';
import '../css/barvy.css';
import '../css/style.css';
import { motion } from "framer-motion";
import { NavLink, useParams } from 'react-router-dom';
import testbike from "../images/bikes/1.png";
import builder from '../utils/builderWithLocale';
import { bikeBelongsToCategory, getBikeField, getBikeTags } from '../editry/cms';
import { useState } from 'react';
import SeznamKolaLoader from "../website/seznamkol-loader";
import { useMemo } from 'react';
import { getLocalizedText } from '../utils/textLocalization';
import '../components/BikeCard.css';

// Tags drive the icons: NEW shows the corner badge, the rest map to an icon next to the name.
const NEW_TAG = "NEW";
const ICON_BY_TAG = { "E-BIKE": "ELETRIC" };


function App({ bikeData }) {
  // Get localized text
  const bikesText = getLocalizedText('general.bikes_caps');
  const allBikesText = getLocalizedText('general.all_bikes');
  const showButtonText = getLocalizedText('general.show_button');
  const pruvodceButtonText = getLocalizedText('general.pruvodce_button');
  const pruvodceText = getLocalizedText('general.pruvodce_text');

  const { kategorie } = useParams();
  const [kategorieDataS, setKategorieDataS] = useState(null);
  const [bikeDataCorrected, setBikeDataCorrected] = useState([]);
  const [loading, setLoading] = useState(true);

  const [activeTag, setActiveTag] = useState("Tag0");

  const [ikony, setIkony] = useState([]);

  const [tooltip, setTooltip] = useState(null);

  useEffect(() => {
    const fetchIkony = async () => {
      try {
        const response = await builder.getAll("ikony");
        let ikonyArray;
        if (Array.isArray(response)) {
          ikonyArray = response;
        } else if (typeof response === 'object' && response !== null) {
          ikonyArray = Object.values(response)[0] || [];
        } else {
          ikonyArray = [];
        }
        const processedIkony = ikonyArray.map(item => ({
          id: item.id,
          nazev: item.data.nazev,
          ikona: item.data.ikona
        }));
        setIkony(processedIkony);
      } catch (error) {
        console.error("Chyba při načítání ikon:", error);
      }
    }
    fetchIkony();
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const normalizedKategorie = kategorie.toLowerCase().trim();
        
        const categories = await builder.getAll("pick-4");
        //console.log(categories);

        const matchingCategory = categories.find(cat => 
          cat.data && cat.data.cesta && 
          cat.data.cesta.toLowerCase().trim() === normalizedKategorie
        );
        
        if (matchingCategory) {
          document.title = "Ridley | " + matchingCategory.data.nazev.toUpperCase();
          setKategorieDataS(matchingCategory);
        } else {
          console.error("Kategorie nebyla nalezena");
          setKategorieDataS(null);
        }
      } catch (error) {
        console.error("Chyba při načítání dat:", error);
        setKategorieDataS(null);
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
  }, [kategorie]);

  const handleScroll = (e) => {
    const hash = e.currentTarget.hash.substring(1);
    setTimeout(() => {
      const element = document.getElementById(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  useEffect(() => {
    setBikeDataCorrected([]);
    const fetchBikes = async () => {
      if (!kategorieDataS || !kategorieDataS.id) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);

          const data = bikeData;

          const filteredBikes = Array.isArray(data)
            ? data.filter((bike) => bikeBelongsToCategory(bike, kategorieDataS))
            : [];
        
          setBikeDataCorrected(filteredBikes);
          setLoading(false);
      } catch (error) {
        console.error("Chyba při načítání kol:", error);
        setLoading(false);
      }
    }

    fetchBikes();
  }, [kategorieDataS, bikeData]);

  const setTag = (input) => {
    setActiveTag(input)
  }

    const allTags = useMemo(() => {
      const tags = bikeDataCorrected.flatMap(bike => getBikeTags(bike.data)).filter(tag => tag !== NEW_TAG);
      return Array.from(new Set(tags));
    }, [bikeDataCorrected]);


    const filteredBikes = useMemo(() => {
      if (activeTag === "Tag0") return bikeDataCorrected;
        return bikeDataCorrected.filter(bike =>
        getBikeTags(bike.data).includes(activeTag)
      );
    }, [bikeDataCorrected, activeTag]);

  const bikesElements = (() => {
    if (!Array.isArray(filteredBikes) || filteredBikes.length === 0) {
      return (
        <div className="no-bikes-message">
          <p>V této kategorii nejsou žádná kola k dispozici.</p>
        </div>
      );
    }
    return filteredBikes.map((bike, index) => {
      const bikeTags = getBikeTags(bike.data);
      const newIcon = bikeTags.includes(NEW_TAG) ? ikony.find(i => i.nazev === NEW_TAG) : null;
      const tagIcons = bikeTags
        .filter(tag => ICON_BY_TAG[tag])
        .map(tag => ikony.find(i => i.nazev === ICON_BY_TAG[tag]))
        .filter(Boolean);
      const bikeImage = typeof bike.data?.obrazek === "string"
        ? bike.data.obrazek
        : bike.data?.obrazek?.Default;
      return (
        <motion.div key={bike.id || index} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.2 }}>
          <NavLink key={index} to={"/kola/" + kategorieDataS.data.nazev.toLowerCase() + "/" + (bike.id || "example")}>
            <div className="pages-bikes" style={{ position: 'relative' }}>
              {newIcon && (
                <img
                  src={newIcon.ikona}
                  alt="NEW"
                  style={{ position: 'absolute', top: '10px', left: '10px', width: '45px', height: '45px', zIndex: 10, cursor: 'pointer' }}
                  onMouseEnter={(e) => {
                    const rect = e.target.getBoundingClientRect();
                    setTooltip({
                      text: newIcon.nazev,
                      x: rect.left + rect.width / 2,
                      y: rect.top - 20
                    });
                  }}
                  onMouseLeave={() => setTooltip(null)}
                />
              )}
              <div className="image-blocker">
                <img 
                  src={bikeImage ? bikeImage + "?format=webp" : testbike} 
                  alt={bike.data?.nazev || "Kolo"} 
                />
              </div>
              <h1>
                {bike.data?.nazev || "Neznámé kolo"}
                {tagIcons.map((icon) => {
                  return icon ? (
                    <img
                      key={icon.id}
                      src={icon.ikona}
                      alt={icon.nazev}
                      style={{ width: '35px', height: '35px', marginLeft: '5px', marginBottom: '7px', verticalAlign: 'middle', cursor: 'pointer' }}
                      onMouseEnter={(e) => {
                        const rect = e.target.getBoundingClientRect();
                        setTooltip({
                          text: icon.nazev,
                          x: rect.left + rect.width / 2,
                          y: rect.top + -20
                        });
                      }}
                      onMouseLeave={() => setTooltip(null)}
                    />
                  ) : null;
                })}
              </h1>
              <p>{getBikeField(bike.data, 'oProduktu', "Popis není k dispozici")}</p>
              <button className="seznamkola-button button-left"><span>{showButtonText}</span></button>
                <div className="tags-on-bike">

                  {bikeTags.filter(tag => tag !== NEW_TAG).map((tag, i) => (
                    <h4 key={i}><span>{tag}</span></h4>
                  ))}

                </div>
            </div>
          </NavLink>
        </motion.div>
      );
    });
  })();

  return (
    <>
      {!loading && kategorieDataS && kategorieDataS && (
        <>
          {kategorieDataS.data.obrazek2 != null && ( 
            <div className="page-background-bike-list">
              <img src={kategorieDataS.data.obrazek2} alt="Ridley pozadí kola" />
              <div />
            </div>
          )}
        </>
      )}

      <motion.div className="page" key="loading" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}>
        {loading ? (
          <>
            <SeznamKolaLoader />
          </>
        ) : kategorieDataS && kategorieDataS.data ? (
          <>
          <div className="page-container page-container-bikes">
            <div className="page-boxes">

              <div className="cesta-seznam cesta-seznam-kol">
                <NavLink to="/#kola" onClick={handleScroll}><button><span>{bikesText}</span></button></NavLink>
                <button className="cesta-active"><span>{kategorieDataS.data.nazev.toUpperCase() || "loading"}</span></button>
              </div>

              <h1>{kategorieDataS.data.nazev || "Kategorie"}</h1>
              <h2 dangerouslySetInnerHTML={{ __html: kategorieDataS.data.popisKategorie }}></h2>

              <div className="tags-rework">
              <button onClick={() => setTag("Tag0")} className={activeTag === "Tag0" ? "tags-rework-active" : ""}>
                <span>{allBikesText}</span>
              </button>
              {allTags.map((tag, index) => (
                <button key={index} onClick={() => setTag(tag)} className={activeTag === tag ? "tags-rework-active" : ""}>
                  <span>{tag}</span>
                </button>
              ))}
              </div>

              { (kategorieDataS.data.nazev.toUpperCase() === "GRAVEL" || kategorieDataS.data.nazev.toUpperCase() === "ROAD") && (
              <div className="seznamkol-pruvodce">
                <p>{pruvodceText}</p>
                <NavLink to={"/pruvodce/" + kategorieDataS.data.nazev.toLowerCase()}><button><span>{pruvodceButtonText}</span></button></NavLink>
              </div>
              )}

              <div className="page-boxes-container">
                {bikesElements}
              </div>
            </div>
          </div>
          </>
        ) : (
          <>
            <SeznamKolaLoader />
          </>
        )}
      </motion.div>
      {tooltip && (
        <div
          style={{
            position: 'fixed',
            left: tooltip.x,
            top: tooltip.y,
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            color: 'white',
            padding: '5px 10px',
            borderRadius: '4px',
            fontSize: '12px',
            whiteSpace: 'nowrap',
            zIndex: 1000,
            transform: 'translateX(-50%)',
            pointerEvents: 'none'
          }}
        >
          {tooltip.text}
        </div>
      )}
    </>
  );
}

export default App;